import { render } from "./App.vue?vue&type=template&id=eef25c5a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=eef25c5a&lang=scss"

import exportComponent from "D:\\Softsion\\Vue\\web-app-topup\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__